import { getGameInfo } from '@shared/api-utils';
import { getConfig, type Currency } from '@shared/utils';
import { cache } from 'react';

const fetchGameInfo = cache(async (gameName: string, currency: Currency) => {
  const { apiUrl, apiLocale } = getConfig();

  return getGameInfo(apiUrl, apiLocale, currency, gameName);
});

export { fetchGameInfo };
